import * as React from 'react';
import { Select, Option } from '@cian/ui-kit';
import { useFormikContext, Field } from 'formik';
import { IFormValues } from '../../DealRentModal';
import { Label } from '../Label';
import { useFieldHasErrors } from '../utils';
import * as styles from '../../index.css';

export interface IChildrenInfoItemProps {
  index: number;
  options: string[];
}

export const ChildrenInfoItem = ({ index, options }: IChildrenInfoItemProps) => {
  const { setFieldValue } = useFormikContext<IFormValues>();
  const name = `childrenInfo[${index}]` as 'childrenInfo';
  const invalid = useFieldHasErrors(name);
  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>, value: string) => setFieldValue(name, value),
    [setFieldValue, name],
  );

  return (
    <div key={name} className={styles['field']}>
      <Label invalid={invalid}>{`Ребенок ${index + 1}`}</Label>
      <Field placeholder="Возраст" as={Select} onChange={onChange} name={name} custom={{ invalid }}>
        {options.map(value => (
          <Option key={value} value={value}>
            {value}
          </Option>
        ))}
      </Field>
    </div>
  );
};
